import styled from 'styled-components';

import { size } from '../layout/helpers';

export const Wrapper = styled.div`
  font-size: 0.875rem;
  color: var(--text-color-error, ${(props) => props.theme.color.ui.negative});
  margin-top: ${size(0.5)};
`;